

import "../../../Foundation/stylable/default-scroll-bar.st.css.js";
import { classesRuntime, statesRuntime } from "./../../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_220_3_SidePanelContent";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_220_3_SidePanelContent__root","defaultScrollBar":"wds_1_220_3_defaultscrollbar__defaultScrollBar"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-side-panel-content-padding-vertical":"--wds-side-panel-content-padding-vertical","wds-side-panel-content-padding-horizontal":"--wds-side-panel-content-padding-horizontal"}; 




